<template>
   <main id="event_body_lotto_attd">
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1>
          <!--<img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">-->
          {{ eventTitle }}
        </h1>
        <img src="images/basic/icon/close-b.svg" onclick="history.back()" alt="">
      </div>
      <div class="div_padding"></div>
         <div>
    <!--
    <div class="eventInfo_status">
      <div class="attendance">
        <p>
          내 참여 <span>{{ listCnt }}</span>
        </p>
        
        <div>
           <img src="images/basic/icon/close-b.svg" onclick="history.back()" alt="">
        </div>
        
      </div>
    </div>
    -->
    <table class="event_rank">
      <thead>
        <tr>
          <td>
            <p>순서</p>
          </td>
          <td>
            <p>닉네임(폰번호)</p>
            <p>참여시간</p>
          </td>
         <td>
          <p>선택번호</p>
        </td>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(atd, idx) in attendanceList" :key="idx" :style="atd.uniqId == uniqId ? 'background:#F2F3F6;' : ''">
          <td>
            <p>{{ listCnt - idx }}</p>
            <img v-if="atd.uniqId == uniqId" src="/images/basic/icon/icon-me.svg" alt="" srcset="">
          </td>
          <td>
            <p>{{ atd.hiddenName }}({{atd.hiddenTelNo}})</p>
            <span>{{ atd.joinDateView }}</span>
          </td>
          <td>
            <p class="number">{{ atd.numberList.toString().replace("[","").replace("]","") }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
    </div>
  </main>
</template>


<script>
import { fetchInfomation, fetchAdCheck, requestCreate, fetchTicket, requestUse, fetchJoinList, fetchMyJoinList, fetchWinnerInfo } from '@/api/ngame'
export default {
  created() {
    fetchMyJoinList({
      eventId: this.$route.query.eventId,
      pageIndex: 1
    }).then(({data}) =>{
      if(data.joinList.length > 0){
        this.searchJoinDate = data.joinList[0].joinDate
      }
      this.listCnt = data.joinListCnt;
      this.attendanceList = [...this.attendanceList, ...data.joinList];
      this.firstLoad = true;
      this.fetchData();
    })
   this.eventTitle = this.$route.query.eventTitle;
  },
  mounted() {
    window.addEventListener("scroll",this.scrollCheck);
  },
  destroyed() {
     window.removeEventListener('scroll', this.scrollCheck);
  },
  data() {
    return {
      eventTitle: "",
      pageIndex: 1,
      listCnt: 0,
      attendanceList: [],
      firstLoad: false,
      searchJoinDate: "",
    }
  },
  computed: {
    uniqId() {      
      return this.$store.state.userInfo.uniqId;
    },
  },
  methods: {
    scrollCheck(){
      const offset = 50;
      var pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,  document.documentElement.clientHeight,  document.documentElement.scrollHeight,  document.documentElement.offsetHeight );
      if ((window.innerHeight + window.scrollY) >= pageHeight - offset) {
        if(this.firstLoad){
          this.fetchData();
        }
      }
    },
    async fetchData() {
      this.pageIndex += 1
      var data = await fetchMyJoinList({
        eventId: this.$route.query.eventId,
        pageIndex: this.pageIndex,
        searchJoinDate: this.searchJoinDate
      })
      this.attendanceList = [...this.attendanceList, ...data.data.joinList];
    },
  },
}
</script>

<style scoped>

</style>